export default {
    NoTipRecoverKey: 'noTipRecover',
    NoTipDeleteKey: 'noTipDelete',
    LocalAutoDeleteTimeKey: 'localAutoDeleteTime'
}